import getCategoryDetailsIfNeeded from "./getCategoryDetailsIfNeeded";
import getSequentialData from "./getSequentialData";
import { fetchServiceBanner } from "../../state/modules/serviceBanner/actions";

const getParallelData = ({
  dispatch,
  store,
  query,
  country,
  language,
  uuid,
  xSiteOrigin,
  isNewPage,
  location,
  shouldReloadCategoryDetails,
  refineForCategoryDetails,
  decisions,
}) =>
  Promise.all([
    getCategoryDetailsIfNeeded({
      dispatch,
      store,
      query,
      country,
      language,
      uuid,
      xSiteOrigin,
      isNewPage,
      location,
      shouldReloadCategoryDetails,
      refineForCategoryDetails,
    }),
    getSequentialData({
      dispatch,
      store,
      query,
      country,
      language,
      uuid,
      xSiteOrigin,
      isNewPage,
      location,
      decisions,
    }),
    dispatch(fetchServiceBanner({ country, uuid, xSiteOrigin })),
  ]);

export default getParallelData;
